import { Component, OnInit, Input } from '@angular/core';
import { Submission } from "../models/submission";
import { SubmissionService } from "../submission.service";
import { Location} from "@angular/common"
import { ParamMap, ActivatedRoute } from "@angular/router";
import {NgPlural} from '@angular/common'
import {TimelineElement} from './horizontal-timeline/timeline-element'
import { Observable } from "rxjs/Observable";

@Component({
  selector: 'app-submission-details',
  templateUrl: './submission-details.component.html',
  styleUrls: ['./submission-details.component.css']
})

export class SubmissionDetailsComponent implements OnInit {

  @Input() submission: Submission;
  error: any;
  commentsData : number[];
  upvoteData : number[];
  commentLabels : Date[];
  upvoteRatioData: number[];
  commentGrowth : number;
  upvoteGrowth: number;
  ratioGrowth: number;
  rankGrowth: number;
  timeline: any[];
  content= "This is the caption";



   public chartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales : {
      xAxes: [{
        type: 'time',
        time: {
          displayFormats: {
            minute: 'h:mm a'
          },
          unit: 'minute'
        }
      }]
    },
    tooltips: {
      callbacks: {
        title: (tooltipItem, data) => {
          return new Date(tooltipItem[0].xLabel).toLocaleTimeString();
        },
        label: (tooltipItem, data) => {
          return `${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel}%`
        }
      }
    }
  };
  public chartLabels:Date[]
  public chartType:string = 'line';
  public chartLegend:boolean = true;
  public chartData:any[] 

  constructor(
    private service : SubmissionService,
    private location : Location,
    private route : ActivatedRoute
  ) { }

  ngOnInit() {
    var paramObservable = this.route.paramMap.switchMap((params:ParamMap) => this.service.getSubmission(params.get('id')));
    paramObservable.subscribe(
      submission => {
        this.populateSubmissionData(submission)
      },
      error => {
        this.error = error;
      });

    paramObservable.catch(e => { return Observable.of(undefined)})
  }

  populateSubmissionData(submission: Submission){
      this.submission = submission;
      this.commentsData = Array.from(submission.datapoints, datapoint => Math.floor(datapoint.num_comments/submission.max_comments*100));
      this.commentLabels = Array.from(submission.datapoints, datapoint => datapoint.readtime);
      this.upvoteData = Array.from(submission.datapoints, datapoint => Math.floor(datapoint.ups/submission.max_ups*100))
      this.upvoteRatioData = Array.from(submission.datapoints, datapoint=> Math.floor(datapoint.upvote_ratio*100))
      this.chartData = [
        {data: this.commentsData, label: "Comments"},
        {data: this.upvoteData, label: "Upvotes"},
        {data: this.upvoteRatioData, label: "Upvote Ratio"}
      ]
      this.commentGrowth = Math.floor(((submission.max_comments - submission.datapoints[0].num_comments)/ submission.max_comments)*100);
      this.upvoteGrowth = Math.floor(((submission.max_ups - submission.datapoints[0].ups)/ submission.max_ups)*100);
      this.ratioGrowth = Math.floor(((submission.max_ratio - submission.datapoints[0].upvote_ratio)/ submission.max_ratio)*100);
      // console.log(submission.max_rank)
      // console.log(submission.datapoints)
      // console.log(submission.datapoints[0].rank)
      this.rankGrowth = submission.max_rank - (submission.datapoints[0].rank+1)
      // console.log(this.rankGrowth)
      this.chartLabels = this.commentLabels
      let rankChanges = [ { date: new Date(submission.created_utc), selected: false, content: "Post created", title: "Post created"},
        { date: new Date(submission.fp_time), selected: true, title: "Front Page Premier", content: `First appearance on front page ranked at ${submission.datapoints[0].rank +1}`}
      ]
      let finalPointAdded = false
      if(this.rankGrowth !== 0) {
        
        for (let i = 1; i < this.submission.datapoints.length; i++){
          if(this.submission.datapoints[i].rank !== this.submission.datapoints[i-1].rank){
            let change = this.submission.datapoints[i]
            let move = change.rank - this.submission.datapoints[i-1].rank
            let plural = move === 1 || move === -1? "spot": "spots"
            if(change.rank === submission.max_rank -1){
              rankChanges.push({ 
              date: new Date(change.readtime), 
              selected: false, 
              title:  move < 0? "Highest Rank Reached": "Rank Loss", 
              content: move < 0? `Post jumped ${Math.abs(move)} ${plural} in the rankings peaking out at number ${submission.max_rank}`: `Lost ${Math.abs(move)} ${plural} in the front page rankings`})
              
            }
            else {
            rankChanges.push({ 
              date: new Date(change.readtime), 
              selected: false, 
              title:  move < 0? "Rank Gain": "Rank Loss", 
              content: move < 0? `Gained ${Math.abs(move)} ${plural} in the front page rankings`: `Lost ${Math.abs(move)} ${plural} in the front page rankings`})
            }
            finalPointAdded = i === this.submission.datapoints.length-1 || finalPointAdded
          }
        }     
      }
      if(!finalPointAdded && submission.datapoints.length > 1)
        rankChanges.push({ 
          date: new Date(submission.datapoints[submission.datapoints.length-1].readtime), 
          selected:false, 
          title: "Last appearance", 
          content: "Last time post was seen on the frontpage"}
        )
      
      rankChanges.sort(this.compare)
      rankChanges = this.removeDuplicates(rankChanges, 'date')
      // console.log(rankChanges)
      this.timeline = rankChanges    
  }
  
  removeDuplicates(myArr, prop : string) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  compare(a:TimelineElement, b: TimelineElement): number{
    if (a.date <  b.date)
      return -1;
    if (a.date > b.date) 
      return 1;
    return 0;

  }

  goBack(): void {
    this.location.back();
  }

  toDurationString(sec_num : number) : string {
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);
    return hours + (hours ==1? " hour ": " hours " )+ minutes + (minutes==1? " minute":" minutes");
  }

  public chartClicked(e:any):void {
    console.log(e);
  }

  public chartHovered(e:any):void {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/submission-details/submission-details.component.ts